'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogLocation = require('./remote/catalogLocation');

var CatalogLocation = {
    fetchCatalogLocations: _catalogLocation.CatalogLocationRemote.fetchCatalogLocations
};

exports.default = CatalogLocation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/catalogLocation.js
// module id = AMoU
// module chunks = 60